module.exports = __webpack_public_path__ + "_assets/img/avator_store.b95bc578.svg";